import {
  EventEmitter
} from "events";
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'

class EmbedService extends EventEmitter {
  getEmbeds(strQuery) {
    return TCVelikClient.GetRelative(`api/Embeds/Get?filter=${strQuery}`);
  }
  getItem(id) {
    return TCVelikClient.GetRelative(`api/Embeds/GetById?Id=${id}`);
  }

  getItemRevisionHistory(id) {
    return TCVelikClient.GetRelative(`api/Embeds/GetVersionHistory?embedId=${id}`);
  }

  publishRevision(comment, revisionId) {
    var payload = {
      RevisionId: revisionId,
      Comment: comment
    }
    return TCVelikClient.PostRelative("api/Embeds/PublishRevision", payload);
  }

  GetStatsForAllProjectsInAccount(projectId, userId) {
    return TCVelikClient.GetRelative(`api/Embeds/GetStatsForAllProjectsInAccount?projectId=${projectId ? projectId : ''}`);
  }

  getFilters(isFlat, includeEmbedsInHierarchy, parentChildEmbedGroupping, filter, withDescriotion) {
    if (!filter)
      filter = '';

    var isFlatNormalized = (isFlat === true);
    var includeEmbedsInHierarchyNormalized = (includeEmbedsInHierarchy === true);

    return TCVelikClient.GetRelative(`api/Embeds/FilterTypes?flat=${isFlatNormalized}&includeEmbedsInHierarchy=${includeEmbedsInHierarchyNormalized}&filter=${encodeURIComponent(filter)}&withDescription=${withDescriotion}`);
  }

  getOkrs() {
    return TCVelikClient.GetRelative(`api/Embeds/GetOkrs`);
  }

  saveEmbed(embed) {
    return TCVelikClient.PostRelative("api/Embeds/Save", embed);
  }

  saveMultipleFeedbackItems(itemsPayLoad) {
    return TCVelikClient.PostRelative("api/Embeds/SaveBulkFeedbackItems", itemsPayLoad);
  }

  deleteBulk(items) {
    var query = {
      items: items
    }
    return TCVelikClient.PostRelative("api/Embeds/DeleteBulk", query);
  }

  reorderEmbed(embedReordreInfo) {
    return TCVelikClient.PostRelative("api/Embeds/Reorder", embedReordreInfo);
  }

  getOnboardingSectionOverview(projectId, userId) {
    return TCVelikClient.GetRelative(`api/Embeds/GetOnboardingSectionOverview?projectId=${projectId}&userId=${userId}`);
  }

  getGuides() {
    return TCVelikClient.GetRelative("api/Guides/Get");
  }
}
export default new EmbedService();
